import { EntityList } from '@avangard/utils/entity';

import { StudentParentEntity } from './student-parent.entity';

import type { Entity } from './student-parent.entity';

class StudentParentEntityList extends EntityList<StudentParentEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(StudentParentEntity, items, count);
    }
}

export { StudentParentEntityList };
